import React from 'react';
import PropTypes from 'prop-types';
import WeekDays from './WeekDays';
import { getDate } from 'src/utils/DateUtils';
import Days from './Days';
import css from './DayPicker.scss';
import moment from 'moment';

/**
 * DayPicker lays out the days of the week and the weekday labels.
 */
const DayPicker = (props) => {

  /**
   * This method will create the grid layout for out calendar. It will lay out Day objects as cells, each of which
   * can fire off a click event and change the state. layOutGrid uses two nested for loops and adds or subtracts from
   * the working date object as needed to fill out the grid.
   * @param firstOfTheMonth the numeric value corresponding to the day of the week which the first falls on indexed 0
   * @param workingDate the full date object, it's initial value should be equal to the first of the month
   */
	const layOutGrid = (firstOfTheMonth, workingDate) => {
		const rows = [];
		const thisMonth = workingDate.month();

		//First let's lay out the days of the week

		for (let i = 0; i < 6; i++) {
			const days = [];
			for (let j = 0; j < 7; j++) {

        /**
         * If we're in the first array and the first of the month does not fall on a sunday
         * We need to go ahead and move the date back equal to the number of days from sunday we are.
         * This should bring us up to the current date where we'll allow the loop below to fill out the
         * rest of dates.
         */
				if (i === 0 && firstOfTheMonth > 0) {
					workingDate.date(workingDate.date() - firstOfTheMonth);
					for (let k = firstOfTheMonth; k > 0; k--) {
						days.push(<td className={css.prevNextDays} key={workingDate.toISOString()}>
							<Days
								onChange={props.onChange}
								day={workingDate.date()}
								month={workingDate.month()}
								year={workingDate.year()}
                value={props.value}
                isDateTime={props.isDateTime} />
						</td>);
						workingDate.date(workingDate.date() + 1);
					}
					//Let's bring our loop up to date and make sure we don't hit this loop again
					j = firstOfTheMonth;
					firstOfTheMonth = 0;
				}

        /**
         * We're going to use this method to determine whether the day is in the current month
         * and should use the black text styling or a future month and should use the grey styling.
         * We don't need to scan for previous months because the above loop already does that.
         * @returns true if we're in the current month or false if we're in a future month.
         */
				let monthMatch = () => {
					if (workingDate.month() !== thisMonth) {
						return false;
					}
					return true;
				};

				days.push(<td className={monthMatch() ? css.calendarTd : css.prevNextDays} key={workingDate.toISOString()}>
					<Days onChange={props.onChange}
						day={workingDate.date()}
						month={workingDate.month()}
						year={workingDate.year()}
            value={props.value}
            isDateTime={props.isDateTime} />
				</td>);
				workingDate.date(workingDate.date() + 1);
			}
			rows.push(<tr key={i + ""}>{days}</tr>);
		}
		return rows;
	};

	//We need to convert the prop to a Date object
	const date = props.value;
	const dateObject = moment(date);

	//Using that date object let's get the current month and year
	const year = dateObject.year();
	const month = dateObject.month();

	//Now lets grab the first of the month as both a numeric value and a date object. layOutGrid needs these both
	const FirstOfmonthFullDate = getDate(1, month, year);
	const firstDayofMonth = FirstOfmonthFullDate.day();

	return (
		<div>
			<table className={css.table}>
				<tbody>
					<WeekDays daysOfTheWeek={props.daysOfTheWeek} />
					{layOutGrid(firstDayofMonth, FirstOfmonthFullDate)}
				</tbody>
			</table>
		</div>
	);
};

DayPicker.propTypes = {
  /**
   * An array of localized days of the week
   */
	daysOfTheWeek: PropTypes.array,
  /**
   * A working instance of a Date or moment Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatPicker.
   */
	value: PropTypes.oneOfType([
		PropTypes.instanceOf(moment),
		PropTypes.instanceOf(Date),
	]),
  /**
   * A function that should update the value in the text field when one has been selected from the Calendar.
   */
	onChange: PropTypes.func
};

export default DayPicker;


// WEBPACK FOOTER //
// ./src/components/cwdatepicker/DayPicker.jsx